import { render } from "./MAFormModal.vue?vue&type=template&id=f26a342c&scoped=true&ts=true"
import script from "./MAFormModal.vue?vue&type=script&lang=ts"
export * from "./MAFormModal.vue?vue&type=script&lang=ts"

import "./MAFormModal.vue?vue&type=style&index=0&id=f26a342c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f26a342c"]])

export default __exports__